<template lang="pug">
    v-data-table.elevation-1(:headers="headersOrden" item-key='detProductoOrden' :items='detProductoOrden' :search="search" :footer-props="{pagination: {itemsPerPage: 5}}" disable-pagination hide-default-footer sort-by='descripcion' :loading='loading' loading-text='Cargando, por favor espere...')
        template(v-slot:top)
          v-toolbar.header-toolbar(flat dense color='primary' dark)
            v-flex(class="d-flex flex-wrap justify-center")
              v-toolbar-title Orden Compra
              v-divider.mx-4(inset vertical)
              v-spacer
              v-text-field.text-xs-center(v-model='search' append-icon="search" label='Buscar' single-line hide-details color='success')
            v-dialog(v-model='dialog' scrollable persistent content-class="flex xs12 sm6")
              v-card(color='grey_1')
                v-app-bar(dark color='primary')
                  v-toolbar-title.headline Producto
                v-card-text
                  v-row(dense)
                    v-col(cols='12')
                      v-card(color='white')
                        v-card-subtitle.title(style='color: black') Almacenamiento
                        v-card-text
                          v-row(dense)
                            v-col(cols='12' sm='12' md='6')
                              v-text-field(outlined dense v-model='editedItem.idProducto.descripcion' readonly label='Producto')
                            v-col(cols='12' md='6' v-if='config.unidad.valor')
                              v-text-field(outlined dense :value='editedItem.unidad? editedItem.unidad.descripcion : null' readonly label='Unidad de Venta')
                            v-col(cols='12' md='6' v-if='config.idAlmacen.valor')
                              v-autocomplete(autocomplete="off" :menu-props="{closeOnContentClick: true}" outlined dense v-model='almaSelec' :items="idAlmacenArray" @change="almacenSelecionado" label='Almacen')
                                template(v-slot:prepend-item)
                                  v-list(dense)
                                    v-list-item( @click='emp = true')
                                      v-list-item-avatar(color='grey_1')
                                        v-btn.mx-2(fab dark x-small color='success')
                                          v-icon(dark small) mdi-plus
                                      v-list-item-content
                                        v-list-item-title
                                          | Agregar Almacen
                              AlmacenM(:dialog='emp' :editedIndex='-1' @close='emp = false' @save='listarAlmacenes')
                            //Fecha de Vencimiento
                            v-col(cols='12' sm='12' md='6' v-if="config.fechaVen.valor")
                              v-dialog(ref='dialog1' v-model='modalVen', :return-value.sync='dateVen' persistent content-class="flex xs12 sm6")
                                template(v-slot:activator='{ on }')
                                  v-text-field(v-model='editedItem.fechaVen' label='Fecha de Vencimiento' prepend-icon='event' readonly dense outlined v-on='on')
                                v-date-picker(v-model='editedItem.fechaVen' locale="ES" :min='dateVen')
                                  v-spacer
                                  v-btn(small dark color='red' @click='modalVen = false') Cancelar
                                  v-btn(small dark color='success' @click='$refs.dialog1.save(dateVen)') Ok
                    v-col(cols='12')
                      v-card(color='white')
                        v-card-subtitle.title(style='color: black') Montos
                        v-card-text
                          v-row(class='d-flex justify-end')
                            v-col(v-if="compra.bs" sm='12' md='6')
                              v-text-field(outlined dense v-model.number='editedItem.costoU' @keyup="calculos(editedItem.costoU, editedItem.cantidadPedido, editedItem.porcUtilidad, editedItem.porcDescuento, editedItem.porcDescuento)" type='number' min="0" label='Costo(U) Bs' prefix="Bs")
                            v-col(v-else sm='12' md='6')
                              v-text-field(outlined dense v-model.number='editedItem.costoDolar' type='number' min="0" @keyup="calculos(editedItem.costoDolar, editedItem.cantidadPedido, editedItem.porcUtilidad, editedItem.porcDescuento, editedItem.porcDescuento)" label='Costo(U) $' prefix="$")
                            v-col(cols='12' sm='12' md='6')
                              v-text-field(outlined dense v-model='editedItem.cantidadPedido' type='number' min="1" label='Cantidad')
                          v-row(dense)
                            v-col(cols='12' md='4' v-if="config.porcUtilidad.valor")
                              v-text-field(dense outlined v-model='editedItem.porcUtilidad' type='number' min="0" label='% Utilidad')
                            v-col(cols='12' md='4' v-if="config.porcDescuento.valor")
                              v-text-field(dense outlined v-model='editedItem.porcDescuento' type='number' min="0" label='% Descuento')
                            v-col(cols='12' md='4' v-if="config.idIVA.valor")
                              v-select(dense outlined v-model='selecIva' :items="idIVAArray" @change= "IVASeleccionado" label='IVA')
                          v-row(dense)
                            v-col(cols='12' sm='6')
                              v-switch(dense color='success' v-model='editedItem.actPrecio' label='¿Actualizar precio del producto?' )
                          div(v-if="editedItem.actPrecio")  
                            v-row(dense)
                              h4 Moneda base del producto
                            v-row(dense)
                              v-col(cols='6')
                                v-switch(dense color='success' v-model='dolar' label='Dolar' )
                              v-col(cols='6')
                                v-switch(dense color='success' v-model='bs' label='Bs' )
                            v-row(dense)
                              v-col(cols='12' md='4')
                                v-text-field(outlined dense readonly v-model.number="editedItem.precioDolar" type='number' id="precioProd" min="0" label='*Precio Dolar' prefix="$")
                              v-col(cols='12' md='4')
                                v-text-field(dense readonly outlined :value='precioUnitario' label='*Precio Bs' prefix="Bs")
                              v-col(cols='12' md='4')
                                v-text-field(dense readonly outlined :value='precioUnitarioIva' label='Precio((U) + IVA' prefix="Bs")
                          v-row(class='d-flex justify-end' dense)  
                            v-col(cols='12' md='6')
                              v-text-field(dense readonly outlined :value='editedItem.subTotal' label='Subtotal' prefix="Bs")
                            v-col(cols='12' md='6')
                              v-text-field(dense readonly outlined :value='editedItem.total' label='Total' prefix="Bs")
                          v-row(class='d-flex justify-end' dense)
                            v-col(cols='12' sm='12' md='6')
                              v-text-field(dense readonly outlined :value='editedItem.totalDolar' label='Total USD' prefix="$")
                v-card-actions
                  v-spacer
                  v-btn(color='error' small dark @click.native='dialog = false')
                    v-icon mdi-close
                    | Cancelar
                  v-btn(color='success' small dark @click.native='save')
                    v-icon mdi-content-save
                    | Cargar
        template(v-slot:item.action='{ item }')
          v-icon.mr-2(color='success' @click='editItem(item)') mdi-cart-plus
        template(v-slot:no-data)
          h2.pa-2 No se han cargado productos
</template>

<script>
import Api from '@/services/methods'
import AlmacenM from '@/components/modals/AlmacenM'
import { EventBus } from '../Events'
export default {
  props: ['detProductoOrden', 'readHijo', 'config', 'compra'],
  data: () => ({
    emp: false,
    dateVen: new Date().toISOString().substr(0, 10),
    modalVen: false,
    dialog: false,
    dialog1: false,
    cancel: false,
    cerrar: false,
    loading: true,
    dolar: false,
    bs: true,
    headersOrden: [
      {
        text: 'Codigo',
        align: 'center',
        sortable: false,
        value: 'idProducto.nombre'
      },
      {
        text: 'Producto',
        align: 'center',
        sortable: false,
        value: 'idProducto.descripcion'
      },
      {
        text: 'Cantidad Solicitada',
        align: 'center',
        sortable: false,
        value: 'cantidadPedido'
      },
      { text: 'Accion', value: 'action', align: 'center', sortable: false }
    ],
    almacenes: [],
    idAlmacenArray: [],

    producto: [],
    idProductoArray: [],

    iva: [],
    idIVAArray: [],
    precioUnitario: 0,
    precioUnitarioIva: 0,

    valorIva: 0,
    unidadMedida: '',
    search: '',

    almaSelec: [],
    selecIva: [],

    editedIndex: -1,
    indiceAlmacen: 0,
    indiceProducto: 0,
    tasa: 0,

    permisosAlm: {},

    editedItem: {
      idProducto: '',
      actPrecio: true,
      idAlmacen: null,
      unidad: null,
      costoU: 0,
      cantidadPedido: 0,
      subTotal: 0,
      idIVA: null,
      porcDescuento: 0,
      porcUtilidad: 0,
      total: 0,
      fechaVen: '',
      moneda: 'Bs',
      precioDolar: 0,
      costoDolar: 0,
      totalDolar: 0
    },
    defaultItem: {
      idProducto: '',
      actPrecio: true,
      idAlmacen: null,
      unidad: null,
      costoU: 0,
      cantidadPedido: 0,
      subTotal: 0,
      idIVA: null,
      porcDescuento: 0,
      porcUtilidad: 0,
      total: 0,
      fechaVen: '',
      moneda: 'Bs',
      precioDolar: 0,
      costoDolar: 0,
      totalDolar: 0
    }
  }),

  components: {
    AlmacenM
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    'editedItem.cantidadPedido': function (val) {
      if (this.editedItem.cantidadPedido > 0) {
        this.editedItem.subTotal = 0
        if (this.compra.bs) {
          this.calculos(this.editedItem.costoU, val, this.editedItem.porcUtilidad, this.editedItem.porcDescuento, this.valorIva)
        } else {
          this.calculos(this.editedItem.costoDolar, val, this.editedItem.porcUtilidad, this.editedItem.porcDescuento, this.valorIva)
        }
      } else {
        this.editedItem.cantidadPedido = 0
      }
    },
    'editedItem.porcUtilidad': function (val) {
      if (this.editedItem.porcUtilidad >= 0) {
        if (this.compra.bs) {
          this.calculos(this.editedItem.costoU, this.editedItem.cantidadPedido, val, this.editedItem.porcDescuento, this.valorIva)
        } else {
          this.calculos(this.editedItem.costoDolar, this.editedItem.cantidadPedido, val, this.editedItem.porcDescuento, this.valorIva)
        }
      } else {
        this.editedItem.porcUtilidad = 0
      }
    },
    'editedItem.porcDescuento': function (val) {
      if (this.editedItem.porcDescuento >= 0) {
        if (this.compra.bs) {
          this.calculos(this.editedItem.costoU, this.editedItem.cantidadPedido, this.editedItem.porcUtilidad, val, this.valorIva)
        } else {
          this.calculos(this.editedItem.costoDolar, this.editedItem.cantidadPedido, this.editedItem.porcUtilidad, val, this.valorIva)
        }
      } else {
        this.editedItem.porcDescuento = 0
      }
    },
    'selecIva': function (val) {
      if (val !== '') {
        if (this.compra.bs) {
          this.calculos(this.editedItem.costoU, this.editedItem.cantidadPedido, this.editedItem.porcUtilidad, this.editedItem.porcDescuento, this.valorIva)
        } else {
          this.calculos(this.editedItem.costoDolar, this.editedItem.cantidadPedido, this.editedItem.porcUtilidad, this.editedItem.porcDescuento, this.valorIva)
        }
      }
    },
    'bs': function (val) {
      if (val) {
        this.dolar = false
        this.editedItem.moneda = 'Bs'
      } else {
        this.dolar = true
        this.editedItem.moneda = 'Dolar'
      }
    },
    'dolar': function (val) {
      if (val) {
        this.bs = false
        this.editedItem.moneda = 'Dolar'
      } else {
        this.bs = true
        this.editedItem.moneda = 'Bs'
      }
    },
  },
  created () {
    this.initialize();
    this.permisosAlm = this.$store.state.empresa[0].permisos.find(permiso => permiso.ruta === 'Almacen')

  },
  methods: {
    formato (fecha) {
      return this.$moment(fecha).format('YYYY-MM-DD')
    },
    initialize () {
      this.listarAlmacenes()
      this.listarProductos()
      this.cargarIVA()
      this.tasa = this.$store.state.config.tasa.tasaDia.valor
    },

    validarCrearAlm () {
      return this.permisosAlm?.accion.includes('Crear')
    },

    calculos (costo, cantidad, utilidad, descuento, iva) {
      
      if (this.compra.dolar) {
        if (this.compra.tasaCompra > 0) {
          this.editedItem.costoU = Number.parseFloat(costo * this.compra.tasaCompra).toFixed(2)
        } else {
          this.editedItem.costoU = 0
        }
      }
      else {
        if (this.compra.tasaCompra && this.compra.tasaCompra > 0) {
          this.editedItem.costoDolar = Number.parseFloat(costo / this.compra.tasaCompra  ).toFixed(2)
        } else {
          this.editedItem.costoDolar = 0
        }
        
      }

      let precio = this.editedItem.costoU * cantidad
      let valorUti = (utilidad / 100) * precio
      let valorDesc = (descuento / 100) * precio
      this.editedItem.subTotal = precio - valorDesc
      let valorIva = this.editedItem.subTotal * iva
      this.editedItem.total = this.editedItem.subTotal + valorIva
      if (this.compra.tasaCompra && this.compra.tasaCompra > 0) {
        this.editedItem.totalDolar = this.editedItem.total / this.compra.tasaCompra
      } else {
        this.editedItem.totalDolar = 0
      }
      this.editedItem.totalDolar = Number.parseFloat(this.editedItem.totalDolar).toFixed(2)
      
      let uti = (this.editedItem.subTotal + valorUti) / cantidad

      this.precioUnitario = Number.parseFloat(uti).toFixed(2)
      
      let utiIva = (this.editedItem.total + valorUti) / cantidad

      this.precioUnitarioIva = Number.parseFloat(utiIva).toFixed(2)

      let dolar = 0
      let tasaDia = Number.parseFloat(this.tasa)
      if (tasaDia > 0) {
        dolar = uti / tasaDia  
      }
      this.editedItem.precioDolar = Number.parseFloat(dolar).toFixed(2)
    },

    almacenSelecionado (data) {
      const almaSelec = this.almacenes.find(almaSelec => almaSelec._id === data)
      this.editedItem.idAlmacen = almaSelec
    },
    IVASeleccionado (data) {
      const ivaSelec = this.iva.find(ivaSelec => ivaSelec._id === data)
      this.editedItem.idIVA = ivaSelec
      this.valorIva = ivaSelec.valor
    },
    listarProductos () {
      Api.get('producto')
        .then(response => {
          this.producto = response.data
          this.loading = false
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
             // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },
    listarAlmacenes () {
      Api.get('almacen')
        .then(response => {
          this.almacenes = response.data
          this.almacenes.map(data => {
            this.idAlmacenArray.push({
              text: data.descripcion,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
             // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },
    cargarIVA () {
      Api.get('iva')
        .then(response => {
          this.iva = response.data
          this.iva.map(data => {
            this.idIVAArray.push({
              text: data.descripcion,
              value: data._id,
              valor: data.valor
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
             // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },
    editItem (item) {
      this.editedIndex = this.detProductoOrden.indexOf(item)
      this.editedItem = Object.assign({}, this.defaultItem)
      this.dialog = true
      this.selecIva = ''
      this.almaSelec = ''
      console.log(item.idProducto)
      this.editedItem.idProducto = item.idProducto
      this.editedItem.unidad = this.editedItem.idProducto.unidadMedida
      this.editedItem.cantidadPedido = item.cantidadPedido
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.selecIva = ''
        this.selecPro = ''
        this.selecAlma = ''
        this.valorIva = 0
        this.precioUnitario = 0
        this.precioUnitarioIva = 0
      }, 300)
    },
    validarCampos () {
      if (
        this.editedItem.idProducto === '' ||
        this.editedItem.idAlmacen === '' ||
        this.editedItem.idIVA === '' ||
        this.editedItem.fechaVen === '' ||
        this.editedItem.unidad === ''
      ) {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor verifique y llene todos los campos para continuar'
        })
        return true
      }
      return false
    },
    validarCantidad () {
      if (this.editedItem.cantidadPedido < 1) {
        this.$swal({
          icon: 'error',
          title: 'La cantidad minima es 1 ',
          text: 'Verifique el campo cantidad'
        })
        return true
      }
      return false
    },
    validarCosto () {
      if (this.editedItem.costoU <= 0) {
        this.$swal({
          icon: 'error',
          title: 'El costo debe ser una cifra positiva ',
          text: 'Verifique el campo Costo'
        })
        return true
      }
      return false
    },
    validarIva () {
      if (!this.editedItem.idIVA) {
        this.$swal({
          icon: 'error',
          title: 'Campo IVA vacio',
          text: 'Debe seleccionar un IVA para el producto'
        })
        return true
      }
      return false
    },
    validarPorc () {
      if (this.editedItem.porcDescuento < 0 || this.editedItem.porcUtilidad < 0) {
        this.$swal({
          icon: 'error',
          title: 'Los porcentajes (%) no pueden ser negativos ',
          text: 'Verifique los campos de Porcentajes'
        })
        return true
      }
      return false
    },
    save () {
      if (!this.validarCampos() && !this.validarCantidad() && !this.validarCosto() && !this.validarPorc() && !this.validarIva()) {
        if (this.editedIndex > -1) {
          // this.editedItem.total = Number.parseFloat(this.editedItem.total).toFixed(2)
          this.editedItem.fechaVen = this.formato(this.editedItem.fechaVen)
          Object.assign(
            this.detProductoOrden[this.editedIndex],
            this.editedItem
          )
        } else {
          // this.editedItem.total = Number.parseFloat(this.editedItem.total).toFixed(2)
          this.editedItem.fechaVen = this.formato(this.editedItem.fechaVen)
          this.detProductoOrden.push(this.editedItem)
          this.$emit('input', (this.value = this.value))
        }
        this.dialog = false
        this.cancel = false
        EventBus.$emit('productoOrden', this.editedItem)
        this.detProductoOrden.splice(this.editedIndex, 1)
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
        this.close()
      }
    }
  }
}
</script>
<style lang="scss">
  @media screen and (max-width: 425px) {
    .header-toolbar, .header-toolbar .v-toolbar__content  {
      height: 80px !important;
    }
    .main-head {
      font-size: 1.3rem;
    }
  }
</style>